import { PROGRAMA_UNIAO_FAZ_A_VIDA_ID } from './Programas';
import { PUFVAdministradorPermissions } from '../store/modules/permissions/PUFVAdministrator';
import { PUFVCentralPermissions } from '../store/modules/permissions/PUFVCentral';
import { PUFVCooperativaPermissions } from '../store/modules/permissions/PUFVCooperativa';
import { PUFVAssessorPedagogicoPermissions } from '../store/modules/permissions/PUFVAssessorPedagogico';
import { PUFVCoordenadorLocalPermissions } from '../store/modules/permissions/PUFVCoordenadorLocal';
import { PUFVProfessorGestorPermissions } from '../store/modules/permissions/PUFVProfessorGestor';
import { PUFVProfessorPermissions } from '../store/modules/permissions/PUFVProfessor';
import { PUFVOperacionalPermissions } from '../store/modules/permissions/PUFVOperacional';
import { PUFVAssessorPedagogicoGestorPermissions } from '../store/modules/permissions/PUFVAssessorPedagogicoGestor';

export const PROFILE_PUFV_ADMINISTRADOR = PUFVAdministradorPermissions;
export const PROFILE_PUFV_CENTRAL = PUFVCentralPermissions;
export const PROFILE_PUFV_COOPERATIVA = PUFVCooperativaPermissions;
export const PROFILE_PUFV_ASSESSOR_PEDAGOGICO =
  PUFVAssessorPedagogicoPermissions;
export const PROFILE_PUFV_ASSESSOR_PEDAGOGICO_GESTOR =
  PUFVAssessorPedagogicoGestorPermissions;
export const PROFILE_PUFV_COORDENADOR_LOCAL = PUFVCoordenadorLocalPermissions;
export const PROFILE_PUFV_PROFESSOR_GESTOR = PUFVProfessorGestorPermissions;
export const PROFILE_PUFV_PROFESSOR = PUFVProfessorPermissions;
export const PROFILE_PUFV_OPERACIONAL = PUFVOperacionalPermissions;

export const allProfiles = [
  PROFILE_PUFV_ADMINISTRADOR,
  PROFILE_PUFV_CENTRAL,
  PROFILE_PUFV_COOPERATIVA,
  PROFILE_PUFV_ASSESSOR_PEDAGOGICO,
  PROFILE_PUFV_ASSESSOR_PEDAGOGICO_GESTOR,
  PROFILE_PUFV_COORDENADOR_LOCAL,
  PROFILE_PUFV_PROFESSOR_GESTOR,
  PROFILE_PUFV_PROFESSOR,
  PROFILE_PUFV_OPERACIONAL,
];

export const allProfileIds = (() => {
  return allProfiles.map((profile) => profile.id);
})();

export const allProfilesForProgramas = {
  [PROGRAMA_UNIAO_FAZ_A_VIDA_ID]: [
    PROFILE_PUFV_ADMINISTRADOR,
    PROFILE_PUFV_CENTRAL,
    PROFILE_PUFV_COOPERATIVA,
    PROFILE_PUFV_ASSESSOR_PEDAGOGICO,
    PROFILE_PUFV_ASSESSOR_PEDAGOGICO_GESTOR,
    PROFILE_PUFV_COORDENADOR_LOCAL,
    PROFILE_PUFV_PROFESSOR_GESTOR,
    PROFILE_PUFV_PROFESSOR,
    PROFILE_PUFV_OPERACIONAL,
  ],
};
